import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
export function useNotificationPreferences() {
    return useQuery({
        queryKey: ['notification-preferences'],
        queryFn: () => apiClient('/students/me/preferences'),
        staleTime: 1000 * 60 * 5,
    });
}
export function useUpdateNotificationPreferences() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (emailEnabled) => apiClient('/students/me/preferences', {
            method: 'PATCH',
            body: JSON.stringify({ email_notifications_enabled: emailEnabled }),
        }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['notification-preferences'] }),
    });
}
//# sourceMappingURL=useNotificationPreferences.js.map